import { useSnapshot } from 'valtio'

import { mainAtom } from '../main'
import { setAllMainSelection } from '../write/setAllMainSelection'

export const useAllMainSelection = () => {
  return [useSnapshot(mainAtom).selection, setAllMainSelection] as const
}
